import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

const VIDEO_END_THRESHOLD_SECONDS = 5;

const isFinalFragment = (fragmentEndTime: number, totalDuration: number | undefined): boolean => {
    if (totalDuration === undefined) {
        return false;
    }

    const timeUntilEnd = totalDuration - fragmentEndTime;
    return timeUntilEnd <= VIDEO_END_THRESHOLD_SECONDS;
};

const COMPLETION_THRESHOLD = 0.95; // 95% просмотра

interface WatchingCompletionParams {
    currentTime?: number | null;
    duration?: number | null;
    skippableFragments: SkippableFragment[] | undefined;
    toleranceMs?: number;
}

export function isWatchingCompleted({
    currentTime,
    duration,
    skippableFragments,
    toleranceMs = 0,
}: WatchingCompletionParams): boolean {
    if (!duration || !currentTime) {
        return false;
    }

    const adjustedCurrentTime = currentTime + toleranceMs / 1000;

    const creditsFragments =
        skippableFragments?.filter((fragment) => fragment.type === 'CREDITS') ?? [];

    const endingCredits = creditsFragments.find((fragment) =>
        isFinalFragment(fragment.endTime, duration)
    );

    if (endingCredits) {
        return adjustedCurrentTime >= endingCredits.startTime;
    }

    if (creditsFragments.length > 0) {
        const latestCreditsEndTime = Math.max(...creditsFragments.map(({ endTime }) => endTime));

        return adjustedCurrentTime >= latestCreditsEndTime;
    }

    return adjustedCurrentTime / duration > COMPLETION_THRESHOLD;
}
